import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'
import { VerificationStatus } from '@/types/verification'

interface VerificationStatusData {
    verification?: {
        overallStatus: VerificationStatus
        status?: VerificationStatus
    }
    status?: VerificationStatus
    overallStatus?: VerificationStatus
}

interface VerificationStatusResponse {
    success: boolean
    message: string
    data: VerificationStatusData
}

export const verificationRtkApi = createApi({
    reducerPath: 'verificationRtkApi',
    baseQuery: fetchBaseQuery({
        baseUrl: `${(import.meta.env.VITE_API_URL || 'http://localhost:5000').replace(/\/api$/, '')}/api/v1`,
        credentials: 'include',
        prepareHeaders: (headers) => {
            const token = localStorage.getItem('token')
            if (token) {
                headers.set('authorization', `Bearer ${token}`)
            }
            return headers
        },
    }),
    tagTypes: ['Verification'],
    endpoints: (builder) => ({
        getVerificationStatus: builder.query<VerificationStatus, void>({
            query: () => '/verification/status',
            transformResponse: (response: VerificationStatusResponse) => {
                const data = response.data
                return (
                    data.verification?.overallStatus ||
                    data.status ||
                    data.overallStatus ||
                    'unverified'
                ) as VerificationStatus
            },
            providesTags: ['Verification'],
            keepUnusedDataFor: 30,
        }),
    }),
})

export const { useGetVerificationStatusQuery } = verificationRtkApi
